export const globalSettingsSystemProjectDeleteRoute = {
	name: 'global-settings-system-project-delete',
	path: '/secure/project/DeleteProject.jspa',
};
